import React, { useEffect, useRef, useState } from "react";
import { EnvelopeIcon, PhoneIcon, InboxArrowDownIcon } from "@heroicons/react/24/outline";
import { Input, Textarea, Button } from "@material-tailwind/react";
import options from '../Data/Servicios.json';
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import emailjs from '@emailjs/browser';
import ReCAPTCHA from "react-google-recaptcha";

import { useLocation } from "react-router-dom";


export default function Contactcontent() {
    const recaptchaRef = useRef(null);
    const [captchaToken, setCaptchaToken] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);


    const API_MAIL_URL = "https://apipraxisplus.voxcom.cl/send/mail/voxcom/";
    const SITE_KEY = "6LesADEsAAAAALPpNGCNqqgbCQIsfBLS2O7C7pMk";
    
    const [formData, setFormData] = useState({ user_name: '', user_lastname: '', user_email: '', user_phone: '', vox_area: '', vox_service: '', message: '' });

    const handleChange = (e) => {
        const { name, value } = e.target || e;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const sendEmail = async (e) => {
    e.preventDefault();
console.log("ingreso a enviar correo");
    try {
        setIsSubmitting(true);

        // Ejecuta el reCAPTCHA invisible y obtiene el token
        const token = await recaptchaRef.current?.executeAsync();

        

        if (!token) {
            toast.error('No se pudo validar el reCAPTCHA. Intenta nuevamente.', {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }

        setCaptchaToken(token);

        const form = document.querySelector('form');

           console.log("Enviar correo");

        /*
        const result = await emailjs.sendForm(
            process.env.REACT_APP_SERVICE_ID,
            process.env.REACT_APP_TEMPLATE_ID,
            form,
            process.env.REACT_APP_PUBLIC_KEY
        );
        */

        /*const formEl = document.querySelector('form');*/
        const fd = new FormData(form);

        const cuerpo = `
        <strong>Nombre:</strong> ${fd.get("user_name") ?? ""} ${fd.get("user_lastname") ?? ""}<br>
        <strong>Email:</strong> ${fd.get("user_email") ?? ""}<br>
        <strong>Phone:</strong> ${fd.get("user_phone") ?? ""}<br>
        <strong>Area:</strong> ${fd.get("vox_area") ?? ""}<br>
        <strong>Service:</strong> ${fd.get("vox_service") ?? ""}<br>
        <strong>Mensaje:</strong> ${fd.get("message") ?? ""}
        `;
        console.log(cuerpo);
		
		const payload = {
		sendTo:	'contacto@voxcom.cl',
		cc: 'karina.tapia@voxcom.cl',
		subject: 'Contacto desde sitio web Voxcom',
		body: cuerpo,
        attachment: []
		};
        const result = await fetch(API_MAIL_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        });

        const dataResponse = await result.json();

        console.log("Response: " + dataResponse.codError);

        setFormData({ user_name: '', user_lastname: '', user_email: '', user_phone: '', vox_area: '', vox_service: '', message: '' });

//        if (result?.text === 'OK') {
        if (dataResponse.codError === 0) {
            toast.success('Mensaje enviado correctamente', {
                position: toast.POSITION.TOP_CENTER,
            });

            form.reset();

            // Resetea el reCAPTCHA y token local
            recaptchaRef.current?.reset();
            setCaptchaToken("");

            setSelectedOption(null);
            setSubSelectedOption(null);
            localStorage.removeItem('ESP');
            localStorage.removeItem('SER');
        } else{
            throw new Error(dataResponse.msgError);
        }
    } catch (error) {
        console.log(error?.text || error);
        toast.error('Ocurrió un error enviando el mensaje. Intenta nuevamente.', {
            position: toast.POSITION.TOP_CENTER,
        });
    } finally {
        setIsSubmitting(false);
    }
};

    function handleChangeEspecialidad(selEspecialidad) {
        var espSel = selEspecialidad.value;
        setSelectedOption(selEspecialidad);
        var espIndex = options.findIndex(({ value }) => value === espSel);
        var arrServicio = options[espIndex].servicio;
        setSubSelectedOption(arrServicio[0]);

    };

  const location = useLocation();

useEffect(() => {
  if (location.hash === "#form") {
    const formElement = document.getElementById("form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  }
}, [location]);


    const [selectedOption, setSelectedOption] = useState(null);
    const [subSelectedOption, setSubSelectedOption] = useState(null);

    var esp = localStorage.getItem("ESP");
    var ser = localStorage.getItem("SER");

    useEffect(() => {
        var espDefault = options.find(({ value }) => value === esp);
        if (espDefault) {
            setSelectedOption(espDefault);
            var espIndex = options.findIndex(({ value }) => value === esp);
            var arrServicio = options[espIndex].servicio;
            if (arrServicio) {
                var serDefault = arrServicio.find(({ value }) => value === ser);
                setSubSelectedOption(serDefault);
            }
        }
    }, [esp, ser]);

    console.log(localStorage.getItem("ESP"));
    console.log(selectedOption);

    console.log(localStorage.getItem("SER"));
    console.log(subSelectedOption);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            border: '1px solid #e2e8f0',
            borderRadius: '0.375rem',
            width: '100%',
            fontSize: '0.875rem',
            position: 'relative',
        }),
        indicatorSeparator: () => ({}),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#DCE0E6',
        }),
        menu: (provided) => ({
            ...provided,
            border: '1px solid #e2e8f0',
            borderTop: 'none',
            borderRadius: '0 0 0.375rem 0.375rem',
            backgroundColor: '#ffffff',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        }),
        option: (provided, state) => ({
            ...provided,
            padding: '0.75rem 1rem',
            '&:hover': {
                backgroundColor: '#edf2f7',
                color: '#455a64'
            },
            '&:focus': {
                backgroundColor: '#edf2f7',
            },
            backgroundColor: state.isSelected ? '#455a64' : 'transparent',
            color: state.isSelected ? '#ffffff' : '#455a64',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#607d8b',
        }),
    };

    console.log("SelectedOption")
    console.log(selectedOption);
    console.log("SubSelectedOption")
    console.log(subSelectedOption?.label);

    return (
        <>
            <ToastContainer />
            <section id="contact" className="bg-white dark:bg-gray-900">
                <div className="container px-6 py-12 mx-auto">
                    <div>
                        <p className="font-medium text-blue-500 dark:text-blue-400">Contacto</p>

                        <h1 className="mt-2 text-2xl font-semibold text-gray-800 md:text-3xl dark:text-white">Conversemos</h1>

                        <p className="mt-3 text-gray-500 dark:text-gray-400">Escríbenos o llámanos por el canal que prefieras.</p>
                    </div>

                    <div className="grid grid-cols-1 gap-12 mt-10 md:grid-cols-2 lg:grid-cols-3">
                        <div>
                            <span className="inline-block p-3 text-blue-500 rounded-full bg-blue-100/80 dark:bg-gray-800">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                                    stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                </svg>
                            </span>

                            <h2 className="mt-4 text-lg font-medium text-gray-800 dark:text-white">Correo electrónico</h2>
                            <p className="mt-2 text-gray-500 dark:text-gray-400">Canal directo para consultas y solicitudes.</p>
                            <a
  href="mailto:contacto@voxcom.cl"
  aria-label="Enviar correo a contacto@voxcom.cl"
  className="mt-2 block text-blue-500 dark:text-blue-400 hover:text-indigo-600 dark:hover:text-blue-300 transition-colors"
>
  contacto@voxcom.cl
</a>
                        </div>

                        <div>
                            <span className="inline-block p-3 text-blue-500 rounded-full bg-blue-100/80 dark:bg-gray-800">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                                    stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                </svg>
                            </span>

                            <h2 className="mt-4 text-lg font-medium text-gray-800 dark:text-white">Dirección</h2>
                            <p className="mt-2 text-gray-500 dark:text-gray-400">Oficina principal de Voxcom.</p>
                         <a
    href="https://goo.gl/maps/NU8nWcRue1PRGKp9A"
    target="_blank"
    rel="noopener noreferrer"
    className="mt-2 block text-blue-500 dark:text-blue-400 hover:text-indigo-600 dark:hover:text-blue-300 transition-colors"
  >
    Matías Cousiño 82, Oficina 704, Santiago, Chile.
  </a>
</div>

                        <div>
                            <span className="inline-block p-3 text-blue-500 rounded-full bg-blue-100/80 dark:bg-gray-800">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                                    stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                </svg>
                            </span>

                            <h2 className="mt-4 text-lg font-medium text-gray-800 dark:text-white">Teléfono</h2>
                            <p className="mt-2 text-gray-500 dark:text-gray-400">Atención de lunes a viernes, de 8:00 a 17:00 hrs.</p>
                            <a
  href="tel:+56222529000"
  aria-label="Llamar al +56 2 2252 9000"
  className="mt-2 block text-blue-500 dark:text-blue-400 hover:text-indigo-600 dark:hover:text-blue-300 transition-colors"
>
  +56 (2) 2252-9000
</a>
                        </div>
                    </div>
                  
<div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-12">
  
  {/* Santiago */}
  <div className="text-center">
    <h2 className="font-medium text-gray-800 dark:text-white">
      Santiago, Chile
    </h2>

    <p className="mt-2 flex justify-center gap-2 text-blue-500 hover:text-indigo-500 transition-colors">
      <EnvelopeIcon className="w-5" />
      <a href="mailto:cmoyano@voxcom.cl" className="no-underline">
        cmoyano@voxcom.cl
      </a>
    </p>

    <p className="mt-2 flex justify-center gap-2 text-blue-500 hover:text-indigo-500 transition-colors">
      <PhoneIcon className="w-5" />
      <a href="tel:+56997328902" className="no-underline">
        +56 (9) 9732 8902
      </a>
    </p>
  </div>

  {/* Ciudad de México */}
  <div className="text-center">
    <h2 className="font-medium text-gray-800 dark:text-white">
      Ciudad de México, México
    </h2>

    <p className="mt-2 flex justify-center gap-2 text-blue-500 hover:text-indigo-500 transition-colors">
      <EnvelopeIcon className="w-5" />
      <a href="mailto:josue.garcia@voxcom.cl" className="no-underline">
        josue.garcia@voxcom.cl
      </a>
    </p>

    <p className="mt-2 flex justify-center gap-2 text-blue-500 hover:text-indigo-500 transition-colors">
      <PhoneIcon className="w-5" />
      <a href="tel:+525541779236" className="no-underline">
        +52 (55) 4177 9236
      </a>
    </p>
  </div>

  {/* Los Angeles */}
  <div className="text-center">
    <h2 className="font-medium text-gray-800 dark:text-white">
      Los Angeles, Estados Unidos
    </h2>

    <p className="mt-2 flex justify-center gap-2 text-blue-500 hover:text-indigo-500 transition-colors">
      <EnvelopeIcon className="w-5" />
      <a href="mailto:fernando.romero@voxcom.cl" className="no-underline">
        fernando.romero@voxcom.cl
      </a>
    </p>

    <p className="mt-2 flex justify-center gap-2 text-blue-500 hover:text-indigo-500 transition-colors">
      <PhoneIcon className="w-5" />
      <a href="tel:+13109511864" className="no-underline">
        +1 (310) 951 1864
      </a>
    </p>
  </div>

</div>
                </div>
            </section>
            <div >
                <section className="bg-white dark:bg-gray-900">
                    <div className="container px-6 py-12 mx-auto">
                        <p className="font-medium text-blue-500 dark:text-blue-400">Formulario de contacto</p>
                        <h1 className="mt-2 text-2xl font-semibold text-gray-800 md:text-3xl dark:text-white">Cuéntanos sobre tu proyecto</h1>
                        <p className="mt-3 text-gray-500 dark:text-gray-400">Déjanos tus datos y nuestro equipo se pondrá en contacto contigo a la brevedad.</p>
                        <div className="w-full mx-auto md:w-3/4 ">
                            <form
  id="form"
  onSubmit={(e) => sendEmail(e)}
  className="mt-10 mx-auto grid grid-cols-1 gap-12 lg:col-span-2 md:grid-cols-2"
>
                                <Input type="text" required label="Nombre" name="user_name" onChange={(e) => handleChange(e, "user_name")} value={formData.user_name} />
                                <Input type="text" required label="Apellido" name="user_lastname" onChange={(e) => handleChange(e, "user_lastname")} value={formData.user_lastname} />
                                <Input type="email" required label="Correo electrónico" name="user_email" onChange={(e) => handleChange(e, "user_email")} value={formData.user_email} />
                                <Input type="tel" pattern="^(?:\+56|0056|56)?\s?(?:\(?[0-9]{1,3}\)?\s?)(?:[0-9]{1,4}\s?-?\s?){2}[0-9]{2}$" label="Teléfono" name="user_phone" onChange={(e) => handleChange(e, "user_phone")} value={formData.user_phone} />
                                <Select

                                    defaultValue={selectedOption}
                                    placeholder={
                                        <div className="float-left text-blue-gray-500">Área de servicio</div>
                                    }
                                    styles={customStyles}
                                    options={options}
                                    value={selectedOption}
                                    onChange={(selected) => {
                                        handleChangeEspecialidad(selected);
                                        handleChange({ target: { value: selected.label, name: "vox_area", } });
                                    }}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.label}
                                    name="vox_area"
                                />

                                <Select

                                    placeholder={
                                        <div className="float-left text-blue-gray-500">Tipo de servicio</div>
                                    }
                                    styles={customStyles}
                                    options={selectedOption ? selectedOption.servicio : []}
                                    value={subSelectedOption}
                                    onChange={(selected) => {
                                        setSubSelectedOption(selected);
                                        handleChange({ target: { value: selected.label, name: "vox_service" } });
                                    }}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.label}
                                    name="vox_service"
                                />
                                <div className="md:col-span-2">
                                    <Textarea type="text" required label="Escribe los detalles de tu solicitud." name="message" onChange={(e) => handleChange(e, "message")} value={formData.message} />
                                </div>



                                <div className="md:col-span-2 flex flex-col items-center gap-4">
                                    {/* Token para back-end / EmailJS (opcional) */}
                                    <input type="hidden" name="g-recaptcha-response" value={captchaToken} />

                                    {/* reCAPTCHA invisible */}
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        /*sitekey={"6LesADEsAAAAALPpNGCNqqgbCQIsfBLS2O7C7pMk"}*/
                                        sitekey={SITE_KEY}
                                        size="invisible"
                                        onExpired={() => setCaptchaToken("")}
                                        onErrored={() => setCaptchaToken("")}
                                    />

                                    <Button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="w-full h-12 flex items-center justify-center gap-2 disabled:opacity-50"
                                    >
                                        <InboxArrowDownIcon className="w-5 h-5" />
                                        Enviar
                                    </Button>
                                </div>

                            </form>
                        </div>
                    </div >
                </section >
            </div>
        </>
    );
}